import type { Money } from '@meshsmith/shared';
import { formatMoney } from '@meshsmith/shared';

export function price(value: Money | number | null | undefined, currency = 'INR'): string {
  if (value == null) return '';
  return formatMoney(value, currency);
}

export function formatDate(input: string | Date | null | undefined): string {
  if (!input) return '';
  return new Date(input).toLocaleDateString('en-IN', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function classNames(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}

/** "₹1,499" for whole rupees, "₹145.90" when there are paise: for sentences, where ".00" is noise. */
export function rupees(amount: number, currency = 'INR'): string {
  return formatMoney({ amount, currency }).replace(/\.00$/, '');
}
